import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';
import { TamEkranService } from '../../../services/tam-ekran.service';

/** Ekran başlıklarının (dk-list-header / dk-form-header) solundaki tam ekran düğmesi. */
@Component({
  selector: 'dk-tam-ekran-dugmesi',
  standalone: true,
  imports: [CommonModule, DxButtonModule],
  template: `
    <dx-button
      stylingMode="text"
      [icon]="(tamEkran.aktif$ | async) ? 'collapse' : 'fullscreen'"
      [hint]="(tamEkran.aktif$ | async) ? 'Tam ekrandan çık (Esc)' : 'Tam ekran'"
      [elementAttr]="{ 'aria-label': 'Tam ekran', class: 'tam-ekran-dugmesi' }"
      (onClick)="tamEkran.degistir()"
    ></dx-button>
  `,
})
export class TamEkranDugmesiComponent {
  constructor(public tamEkran: TamEkranService) {}
}
